import { useEffect } from 'react'

import { useLocation } from 'react-router'

import { captureGoogleAdsClickIds, page } from '@/utils/analytics.client'

export default function PlanetScaleAnalytics() {
  const { pathname, search } = useLocation()

  useEffect(() => {
    captureGoogleAdsClickIds()
  }, [search])

  useEffect(() => {
    page()
  }, [pathname])

  return null
}
